import Masonry from "@mui/lab/Masonry";
import { useMasonryColumns } from "src/context/MasonryLayoutProvider";

interface Props {
  children: NonNullable<React.ReactNode>;
  spacing?: string | number;
}

const MasonryLayout = ({ children, spacing = 1 }: Props) => {
  const { columns } = useMasonryColumns();

  return (
    <Masonry columns={columns} spacing={spacing}>
      {children}
    </Masonry>
  );
};

export default MasonryLayout;
